<div class="py-4 container-fluid subject-management-create-page">
  <h4 class="mb-4 subject-management-create-title">การจัดการรายวิชา</h4>

  <div class="subject-management-create-card">
    <div class="subject-management-create-card-body">
      <div class="subject-management-details-loading" *ngIf="loading">กำลังโหลดข้อมูลรายวิชา...</div>
      <div class="subject-management-details-alert" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="subject-management-details-subject-summary">
        <app-subject-info-form
          [subjectForm]="subjectForm"
          [isSaved]="true"
          [allowDelete]="false"
          [subjectApprovalStatusLabel]="subject?.statusLabel ?? null"
          [subjectApprovalStatus]="subject?.status ?? null"
          [academicTermOptions]="academicTermOptions"
          [yearOptions]="yearOptions"
          [subjectTypeOptions]="subjectTypeOptions"
          [subjectOptions]="subjectOptions"
          [curriculumTypeOptions]="curriculumTypeOptions"
          [headerEditorVisible]="isAdminSubjectHeaderEditor"
          [headerEditable]="canEditSubjectHeader"
          [headerSaving]="isSavingSubjectHeader"
          (requestHeaderSave)="onRequestSubjectHeaderSave()"
        ></app-subject-info-form>
      </div>

      <div class="subject-management-create-section-area" *ngIf="!loading">
        <div class="subject-management-create-section-toolbar" *ngIf="!isSubjectManagementViewOnly">
          <button type="button" class="app-button app-button-primary subject-management-create-add-section-button"
            [disabled]="isSavingNewSection" (click)="onAddSection()">
            <img src="assets/media/icons/svg/add-item.svg" alt="" aria-hidden="true" />
            <span>เพิ่ม Section</span>
          </button>
        </div>

        <div class="subject-management-create-empty" *ngIf="sectionForms.length === 0">
          ไม่พบข้อมูล Section ของรายวิชานี้
        </div>

        <app-section-editor
          *ngFor="let section of sectionForms; let i = index"
          [section]="section"
          [sectionIndex]="i"
          [teachingTypeOptions]="teachingTypeOptions"
          [teachingDayOptions]="teachingDayOptions"
          [timeOptions]="timeOptions"
          [teachers]="getSectionTeachersAt(i)"
          [workloadMode]="getSectionWorkloadModeAt(i)"
          [isProjectResearch]="isProjectResearchSectionAt(i)"
          [locked]="false"
          [submitted]="isSectionSubmittedAt(i) && !canExtendNonSplitSectionAt(i)"
          [editable]="isSectionEditableAt(i) || canExtendNonSplitSectionAt(i)"
          [removable]="isNewSectionAt(i)"
          [showStatus]="!isNewSectionAt(i)"
          [teacherManagementEnabled]="canManageTeachersAt(i) && !teacherOptionsLoading"
          [sectionFieldsEditable]="isSectionFieldsEditableAt(i)"
          [workloadHoursEditable]="false"
          [existingTeachingTimesEditable]="isSectionEditableAt(i)"
          [editableTeachingTimeStartIndex]="getExistingTeachingTimeCountAt(i)"
          [respectLockedTeachingTimes]="false"
          [canAddTeachingTime]="isSectionEditableAt(i) || canExtendNonSplitSectionAt(i)"
          [usedTeachingTimeIndexes]="getUsedTeachingTimeIndexesAt(i)"
          [projectTeacherEditability]="getProjectTeacherEditabilityAt(i)"
          [collapsible]="!isNewSectionAt(i)"
          [expanded]="isSectionExpandedAt(i)"
          [statusLabel]="getSectionStatusLabelAt(i)"
          [status]="getSectionStatusAt(i)"
          [approvalReady]="!isNewSectionAt(i) && hasPendingSubmissionChangesAt(i)"
          [saveMode]="isNewSectionAt(i)"
          [isSubmittingApproval]="isSubmittingApproval || isSavingNewSection"
          (expandedChange)="onSectionExpandedChange(i, $event)"
          (addTeachingTime)="onAddTeachingTimeByIndex(i)"
          (removeTeachingTime)="onRemoveTeachingTimeByIndex(i, $event)"
          (manageTeachers)="onManageTeachersByIndex(i)"
          (editProjectTeacher)="onEditProjectTeacher(i, $event)"
          (removeProjectTeacher)="onRemoveProjectTeacher(i, $event)"
          (submitApproval)="onSubmitApprovalByIndex(i)"
          (saveSection)="onSaveNewSectionByIndex(i)"
          (requestRemove)="onDiscardNewSection(i)"
        ></app-section-editor>
      </div>
    </div>
  </div>
</div>

<app-confirm-dialog #subjectHeaderConfirmDialog modalId="subjectManagementDetailsHeaderConfirmDialog"
  title="ยืนยันการแก้ไขข้อมูลรายวิชา"
  message="การแก้ไขนี้จะอัปเดตหลักสูตรและคำอธิบายหน่วยกิตในทุก Section ของรายวิชานี้ ต้องการดำเนินการต่อหรือไม่ ?"
  cancelText="ยกเลิก" confirmText="ยืนยัน" icon="warning" [isProcessing]="isSavingSubjectHeader"
  (confirmed)="onConfirmSubjectHeaderSave()" (cancelled)="onCancelSubjectHeaderSave()"></app-confirm-dialog>

<app-confirm-dialog #subjectHeaderResultDialog modalId="subjectManagementDetailsHeaderResultDialog"
  [title]="subjectHeaderResultTitle" [message]="subjectHeaderResultMessage" [icon]="subjectHeaderResultIcon"
  confirmText="ปิด" [showCancelButton]="false"
  (confirmed)="subjectHeaderResultDialog.close()"></app-confirm-dialog>

<app-confirm-dialog
  #submitApprovalConfirmDialog
  modalId="subjectManagementDetailsSubmitApprovalConfirmDialog"
  title="ยืนยันการส่งขอรับรอง"
  message="โปรดตรวจสอบข้อมูลก่อนส่งขอรับรอง ต้องการดำเนินการต่อหรือไม่ ?"
  cancelText="ยกเลิก"
  icon="warning"
  confirmText="ยืนยัน"
  [isProcessing]="isSubmittingApproval"
  (confirmed)="onConfirmSubmitApproval()"
  (cancelled)="onCancelSubmitApproval()"
></app-confirm-dialog>

<app-confirm-dialog
  #submitApprovalSuccessDialog
  modalId="subjectManagementDetailsSubmitApprovalSuccessDialog"
  title="ส่งขอรับรองสำเร็จ"
  [message]="submitApprovalSuccessMessage"
  icon="success"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="submitApprovalSuccessDialog.close()"
></app-confirm-dialog>

<app-confirm-dialog
  #submitApprovalErrorDialog
  modalId="subjectManagementDetailsSubmitApprovalErrorDialog"
  title="ไม่สามารถส่งขอรับรองได้"
  [message]="submitApprovalErrorMessage"
  icon="error"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="submitApprovalErrorDialog.close()"
></app-confirm-dialog>

<app-confirm-dialog
  #teacherSaveErrorDialog
  modalId="subjectManagementDetailsTeacherSaveErrorDialog"
  title="ไม่สามารถบันทึกข้อมูลผู้สอนได้"
  [message]="teacherSaveErrorMessage"
  icon="error"
  confirmText="ปิด"
  [showCancelButton]="false"
  [stackAboveModal]="true"
  (confirmed)="teacherSaveErrorDialog.close()"
></app-confirm-dialog>

<app-confirm-dialog
  #projectTeacherDeleteErrorDialog
  modalId="subjectManagementDetailsProjectTeacherDeleteErrorDialog"
  title="ไม่สามารถลบผู้สอนได้"
  [message]="projectTeacherDeleteErrorMessage"
  icon="error"
  confirmText="ปิด"
  [showCancelButton]="false"
  [stackAboveModal]="true"
  (confirmed)="projectTeacherDeleteErrorDialog.close()"
></app-confirm-dialog>

<app-confirm-dialog
  #addSectionErrorDialog
  modalId="subjectManagementDetailsAddSectionErrorDialog"
  title="ไม่สามารถบันทึก Section ได้"
  [message]="addSectionErrorMessage"
  icon="error"
  confirmText="ปิด"
  [showCancelButton]="false"
  [stackAboveModal]="true"
  (confirmed)="addSectionErrorDialog.close()"
></app-confirm-dialog>

<app-confirm-dialog
  #deleteItemWarningDialog
  modalId="subjectManagementDetailsDeleteItemWarningDialog"
  title="ยืนยันการลบรายการ"
  [message]="pendingDeleteMessage"
  cancelText="ยกเลิก"
  confirmText="ลบ"
  icon="trash"
  [stackAboveModal]="true"
  [isProcessing]="isDeletingProjectTeacher"
  (confirmed)="onConfirmPendingDelete()"
  (cancelled)="onCancelPendingDelete()"
></app-confirm-dialog>

<app-confirm-dialog
  #saveSectionBeforeManageTeachersConfirmDialog
  modalId="subjectManagementDetailsSaveSectionBeforeManageTeachersConfirmDialog"
  title="ยืนยันการบันทึก Section"
  message="ต้องบันทึก Section นี้ก่อน จึงจะสามารถจัดการผู้สอนได้ ต้องการบันทึกเลยหรือไม่ ?"
  cancelText="ยกเลิก"
  icon="warning"
  confirmText="บันทึก"
  [isProcessing]="isSavingNewSection"
  (confirmed)="onConfirmSaveSectionBeforeManageTeachers()"
  (cancelled)="onCancelSaveSectionBeforeManageTeachers()"
></app-confirm-dialog>

<app-confirm-dialog
  #changeTeacherWorkloadModeConfirmDialog
  modalId="subjectManagementDetailsChangeTeacherWorkloadModeConfirmDialog"
  title="ยืนยันการเปลี่ยนการคิดภาระงาน"
  message="การเปลี่ยนการคิดภาระงานจะล้างช่วงวันที่สอนของผู้สอนทุกคน กรุณาเลือกช่วงวันที่สอนใหม่ ต้องการดำเนินการต่อหรือไม่ ?"
  cancelText="ยกเลิก"
  icon="warning"
  confirmText="ยืนยัน"
  [stackAboveModal]="true"
  (confirmed)="onConfirmTeacherWorkloadModeChange()"
  (cancelled)="onCancelTeacherWorkloadModeChange()"
></app-confirm-dialog>

<app-teacher-management-modal
  [teacherModalForm]="teacherModalForm"
  [teacherDraftRows]="teacherDraftRows"
  [teacherOptions]="teacherOptions"
  [excludedTeacherUserIds]="headApprovedTeacherUserIds"
  [teacherTeachingRangeOptions]="teacherTeachingRangeOptions"
  [midtermStartDate]="academicTermMidtermStartDate"
  [midtermEndDate]="academicTermMidtermEndDate"
  [errorMessage]="teacherModalErrorMessage"
  [editableTeacherRows]="getTeacherDraftRowEditability()"
  [workloadModeEditable]="!shouldDisableWorkloadModeChange()"
  [teacherCollectionEditable]="hasTeacherModalChanges()"
  [addTeacherEditable]="canAddTeacherToCollection()"
  [isSaving]="isSavingTeachers"
  [teachingTimes]="getActiveTeacherTeachingTimes()"
  [workloadHoursText]="activeTeacherSection === null ? '-' : activeTeacherSection.workloadHours"
  (addTeacher)="onAddTeacherDraftRow()"
  (removeTeacher)="onRemoveTeacherDraftRow($event)"
  (teacherSelected)="onTeacherSelected($event.rowIndex, $event.teacher)"
  (saveTeachers)="onSaveTeachers()"
  (cancelTeachers)="onCancelTeachers()"
></app-teacher-management-modal>

<app-project-teacher-modal
  [projectTeacherForm]="projectTeacherForm"
  [projectTeachingTimes]="projectTeachingTimes"
  [teacherOptions]="projectTeacherOptions"
  [teachingDayOptions]="teachingDayOptions"
  [timeOptions]="timeOptions"
  [projectTeacherSubmitted]="projectTeacherSubmitted"
  [isSaving]="isSavingProjectTeacher"
  [saveError]="projectTeacherSaveError"
  (projectTeacherSelected)="onProjectTeacherSelected($event)"
  (addTeachingTime)="onAddProjectTeachingTime()"
  (removeTeachingTime)="onRemoveProjectTeachingTime($event)"
  (teachingTimeChanged)="updateProjectWorkloadHours()"
  (saveProjectTeacher)="onSaveProjectTeacher()"
  (cancelProjectTeacher)="onCancelProjectTeacher()"
></app-project-teacher-modal>
